import Vue from 'vue'
import App from './containers/App.vue'
import Site from './content.js'
import 'babel-polyfill';
// import { VueHammer } from 'vue2-hammer'
import VueYoutube from 'vue-youtube'


Vue.config.productionTip = false
Vue.prototype.$content = Site.pages


// VueHammer.config.swipe = {
//   direction: 'HORIZONTAL'
// };

// Vue.use(VueHammer)
Vue.use(VueYoutube)


new Vue({
  render: h => h(App),
}).$mount('#app')
